module.exports = __webpack_public_path__ + "img/pin-lider.40046b96.png";